// extracted by mini-css-extract-plugin
module.exports = {"Leaderboard":"R2C1F2","section-title":"_1BhKsw"};